import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import Loading from '~/components/Loading'
import { FormGroup, Label, Select } from '~/components/unform'
import { getAdSizesService } from '~/modules/retailMedia/services/ad-size'

type AdSizeFieldsetProps = {
  adType: CampaignAdType
}

const AdSizeFieldset = ({ adType }: AdSizeFieldsetProps) => {
  const assetType = useMemo(() => {
    const imageAdType = ['banner', 'sponsored_brand', 'banner_off_site']
    return imageAdType.includes(adType) ? 'image' : 'video'
  }, [adType])

  const { isPending: adSizeIsPending, data: adSizes } = useQuery({
    queryKey: ['get-ad-sizes', assetType],
    queryFn: async () => {
      const res = await getAdSizesService({ type: assetType })

      return res.data.data
    }
  })

  return adSizeIsPending ? (
    <Loading status={adSizeIsPending} />
  ) : (
    <FormGroup className="d-flex justify-content-between mt-2">
      <Label className="w-75" isRequired text="Size" />

      <Select
        required
        name="size"
        placeholder="Select size"
        options={adSizes?.map(adSize => ({
          label: `${adSize.name} (${adSize.width}x${adSize.height})`,
          value: adSize.name
        }))}
      />
    </FormGroup>
  )
}

export default AdSizeFieldset
